module.exports = {
  title: '赠品商品库',
  route: {
    path: '/marketing-tools',
    children: {
      path: 'gifts-product-list',
    },
  },
};
